<template>
  <div class="bg" :class="is_opaque ? 'is-opaque' : ''"></div>
</template>

<script>
// import axios from "axios"
export default {
  name: "Bg",
  props: ['opaque'],
  data: function() {
    return {
      is_opaque: this.opaque
    }
  },
  watch: {
    opaque(newValue) {
      this.is_opaque = newValue
    }
  },
};
</script>

<style scoped>
.bg {
  background-image: url(../../assets/svg/bg.svg);
  background-position: bottom right;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.is-opaque {
  opacity: .5;
}
</style>